module.exports = __webpack_public_path__ + "static/media/Group2.73158bbe.svg";